import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RackeoLocaleService, RackeoContactData } from '../../services/locale.service';
import { SlaaskChatService } from '../../services/slaask-chat.service';
import { URL } from '../../../../environments/environment';

@Component({
  selector: 'app-rackeo-cta-contact',
  templateUrl: './rackeo-cta-contact.component.html',
  styleUrls: ['./rackeo-cta-contact.component.scss']
})
export class RackeoCtaContactComponent {
  readonly URL = URL;
  readonly contact$: Observable<RackeoContactData | null> = this.locale
    .getContent()
    .pipe(map((c) => c?.contact ?? null));

  constructor(
    private readonly locale: RackeoLocaleService,
    private readonly slaaskChat: SlaaskChatService
  ) {}

  openSlaaskChat(): void {
    this.slaaskChat.open();
  }
}
